import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/fskGKh8x4rzH4bwhdhifYm/ChatGPT_Image_20_abr_2026,_23_14_36.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-8 pb-4 md:pt-10 md:pb-6 px-5 sm:px-6 overflow-hidden relative flex flex-col justify-center" data-id="element-148">
      <div className="absolute inset-0 bg-gradient-to-b from-[#2D1B1B]/40 via-[#1C1410] to-[#1C1410]" data-id="element-149"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#C9A96E]/5 rounded-full blur-3xl pointer-events-none" data-id="element-150"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-151">
        {/* Brand */}
        <div className="mb-2" data-id="element-152">
          <span className="text-[#C4856A] text-[10px] md:text-xs font-bold tracking-[0.25em] uppercase" data-id="element-153">
            🌹 ACADEMIA HOLÍSTICA ARGENTINA 🌹
          </span>
        </div>

        {/* Title */}
        <h1 className="mb-1 font-bold tracking-tight leading-none text-[#C9A96E]" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-154">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl" data-id="element-155">
            EL CÓDIGO DE LA
          </span>
          <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl italic" data-id="element-156">
            HIJA LIBRE
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-[#F5ECD7] font-bold text-base md:text-lg mb-0.5" data-id="element-157">
          Tu camino completo de liberación genealógica. Desde hoy.
        </p>
        <p className="text-[#C9A96E] font-medium text-sm md:text-base mb-3" data-id="element-158">
          6 Tomos + 6 Bonos — Método Sistémico Completo
        </p>

        {/* Product Image */}
        <div className="block mx-auto max-w-[220px] sm:max-w-[320px] md:max-w-md mb-3" data-id="element-159">
          <div className="relative animate-float" data-id="element-160">
            <div className="absolute -inset-3 bg-[#C9A96E]/8 rounded-3xl blur-2xl animate-pulse-glow" data-id="element-161"></div>
            <div className="relative" data-id="element-162">
              <img src={PRODUCT_IMG} alt="El Código de la Hija Libre — MegaPack 6 Tomos" className="w-full object-contain block drop-shadow-[0_12px_40px_rgba(201,169,110,0.3)] mix-blend-lighten" data-id="element-163" />
            </div>
          </div>
        </div>

        {/* Pills */}
        <div className="flex justify-center flex-wrap gap-2 mb-3" data-id="element-164">
          <span className="text-[10px] sm:text-xs text-[#FAF3E8] font-medium bg-[#2D1B1B]/80 border border-[#C9A96E]/20 rounded-full px-2.5 py-1 whitespace-nowrap" data-id="element-165">
            📄 100% PDF
          </span>
          <span className="text-[10px] sm:text-xs text-[#FAF3E8] font-medium bg-[#2D1B1B]/80 border border-[#C9A96E]/20 rounded-full px-2.5 py-1 whitespace-nowrap" data-id="element-166">
            ⚡ Acceso en 5 min
          </span>
          <span className="text-[10px] sm:text-xs text-[#FAF3E8] font-medium bg-[#2D1B1B]/80 border border-[#C9A96E]/20 rounded-full px-2.5 py-1 whitespace-nowrap" data-id="element-167">
            🇦🇷 Argentina
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-2 w-full max-w-md mx-auto" data-id="element-168">
          <a href="#pricing-offer" className="w-full block px-4 py-3.5 md:py-4 rounded-xl text-[#F5ECD7] hover:text-[#1C1410] font-bold text-sm sm:text-base tracking-wider uppercase transition-all shadow-[0_0_30px_rgba(139,38,53,0.4)] hover:shadow-[0_0_40px_rgba(201,169,110,0.6)] hover:-translate-y-1 bg-[#8B2635] hover:bg-[#C9A96E] border border-[#8B2635] hover:border-[#C9A96E] text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-169">
            → QUIERO MI CÓDIGO AHORA
          </a>
          <p className="text-[#C4856A] text-[10px] md:text-xs font-medium tracking-wide" data-id="element-170">
            🛡️ Garantía 7 días | 🔒 Pago seguro | 💳 Mercado Pago
          </p>
        </div>
      </div>
    </section>;
}